import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InputNumberComponent',
  props: {
	placeholder: {
		type: String,
		default: 'Escribe aquí...',
	},
	modelValue: {
		type: Number,
		default: null,
	},
	label: {
		type: String,
		default: 'Label',
	},
	id: {
		type: String,
	},
	hasError: {
		type: Boolean,
		default: false,
	},
	errorMessage: {
		type: String,
		default: '',
	},
	allowDecimals: {
		type: Boolean,
		default: true
	}
},
  emits: ['updateNumber', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const inputNumber = ref<number>(props.modelValue);

const preventDecimal = (e: KeyboardEvent) => {
	if(props.allowDecimals==false){
			if (e.key === '.' || e.key === ',') {
			e.preventDefault();
		}
} 
	
};

watch(inputNumber, (newValue: number) => {
	if (inputNumber.value >= 0) {
		emit('updateNumber', props.id, newValue);
		emit('update:modelValue', newValue);
	}
});

watch(
		() => props.modelValue,
		(newValue) => {
			inputNumber.value = newValue;
		},
		{ immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputNumber).value = $event)),
        placeholder: __props.placeholder,
        class: _normalizeClass(['input-field', {'has-error': __props.hasError}]),
        step: "1",
        onKeypress: preventDecimal,
        ref: "inputRef"
      }, null, 42, _hoisted_3), [
        [_vModelText, inputNumber.value]
      ])
    ]),
    (__props.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})